import { createContext } from 'react';

interface MenuContextProps<ValueType extends string> {
    onMenuAction?: (key: ValueType) => void;
    shouldCloseOnSelect?: (key: string) => boolean;
}
export const MenuContext = createContext<MenuContextProps<string>>({
    onMenuAction: () => {},
    shouldCloseOnSelect: () => true,
});
